import Frisbee from 'frisbee';

export const API_URL =
  process.env.REACT_APP_API_URL || 'https://clubes-api-app.herokuapp.com/api/v1';

const apiBase = new Frisbee({
  baseURI: API_URL,
  mode: 'cors',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export default apiBase;

export const NETWORK_STATES = {
  IDDLE: 'iddle',
  LOADING: 'loading',
  SENDING: 'sending',
  FAILURE: 'failure',
  NOT_FOUND: 'not_found',
  SUCCESS: 'success',
};
